export const LOW_RISK_STATUS = "low_risk";
export const MEDIUM_RISK_STATUS = "medium_risk";
export const HIGH_RISK_STATUS = "high_risk";

export const LOW_RISK_ELIGIBILITY_RESULT = "Low risk, eligible";
export const MEDIUM_RISK_ELIGIBILITY_RESULT = "Medium risk, eligible";
export const HIGH_RISK_ELIGIBILITY_RESULT = "High risk, not eligible";

export const ASSESSMENT_REPORT_STATUSES = {
  [LOW_RISK_ELIGIBILITY_RESULT]: LOW_RISK_STATUS,
  [MEDIUM_RISK_ELIGIBILITY_RESULT]: MEDIUM_RISK_STATUS,
  [HIGH_RISK_ELIGIBILITY_RESULT]: HIGH_RISK_STATUS,
};

export const ASSESSMENT_REPORT_STATUS_KEYS = [
  LOW_RISK_STATUS,
  MEDIUM_RISK_STATUS,
  HIGH_RISK_STATUS,
];

export const EMPLOYER_WIDGET_TYPE = "employer";
export const CANDIDATE_WIDGET_TYPE = "candidate";
export const EMPLOYER_OUTSIDE_WIDGET_TYPE = "employer_outside";
export const EMPLOYER_INSIDE_WIDGET_TYPE = "employer_inside";

export const ASSESSMENT_REPORT_WIDGET_TYPES = {
  [EMPLOYER_WIDGET_TYPE]: EMPLOYER_WIDGET_TYPE,
  [CANDIDATE_WIDGET_TYPE]: CANDIDATE_WIDGET_TYPE,
  [EMPLOYER_OUTSIDE_WIDGET_TYPE]: EMPLOYER_OUTSIDE_WIDGET_TYPE,
  [EMPLOYER_INSIDE_WIDGET_TYPE]: EMPLOYER_INSIDE_WIDGET_TYPE,
};
